import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/motivos-no-elegible`;

export async function getMotivosNoElegible() {
  const response = await axios.get(baseUrl);
  return response.data;
}